<template>
  <div id="dashboard" class="">
    <div class="bannerprincipal pb-2">
      <div class="container">
        <div class="row">
          <div class="col-8 offset-2 col-md-6 offset-md-3 offset-md-0 h-100">
            <div class="">
              <div class="d-flex justify-content-center align-items-center">
                <div class="mt-3 zindex10" data-aos="fade" data-aos-delay="200">
                  <img
                    class="img-fluid"
                    src="../assets/imgs/raspaygana/raspa-y-gana.png"
                    alt="Raspa y Gana"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row pb-5">
        <div class="col-12 col-md-8 offset-md-2 py-5">
          <p class="fXG text-center bold pb-4 blanco">Ganadores</p>

          <p class="fG text-center bold pb-4 blanco">Ganadores Semana 1</p>

          <div class="fM blanco pb-5">
            <table class="tableganadores">
              <tr>
                <td class="bold fG">Nombre</td>
                <td class="bold fG">Premio</td>
              </tr>
              <tr>
                <td>Angel Perches</td>
                <td>Smart TV 58"</td>
              </tr>
              <tr>
                <td>Mariela Morales</td>
                <td>Smart TV 58"</td>
              </tr>
              <tr>
                <td>Olivia Duran</td>
                <td>Smart TV 58"</td>
              </tr>
              <tr>
                <td>Adán Palma</td>
                <td>Smartphone</td>
              </tr>
              <tr>
                <td>Eduardo Escobar</td>
                <td>Smartphone</td>
              </tr>
              <tr>
                <td>Felipe Cristóbal Carrillo</td>
                <td>Smartphone</td>
              </tr>
              <tr>
                <td>Ma. De Refugio Vazquez</td>
                <td>Smartphone</td>
              </tr>
              <tr>
                <td>Victoria Vázquez</td>
                <td>Smartphone</td>
              </tr>
              <tr>
                <td>Álvaro Quintana</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Carlos Muñoz</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Cesar Ramos</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Erika Perea</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Francisco Moreno</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Jorge Rey</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Judith Valerio</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Martín Lopez</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Oscar Prieto</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Ruben Ivan López</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Sergio Elías</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Victor Garcia</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr></tr>
            </table>
          </div>

          <p class="fG text-center bold pb-4 blanco">Ganadores Semana 2</p>

          <div class="fM blanco pb-5">
            <table class="tableganadores">
              <tr>
                <td class="bold fG">Nombre</td>
                <td class="bold fG">Premio</td>
              </tr>

              <tr>
                <td>Eduardo Escobar</td>
                <td>Smart TV 58"</td>
              </tr>
              <tr>
                <td>Juan Herrera</td>
                <td>Smart TV 58"</td>
              </tr>
              <tr>
                <td>Nathan Torres</td>
                <td>Smart TV 58"</td>
              </tr>

              <tr>
                <td>Arturo Alarcón</td>
                <td>Smartphone</td>
              </tr>
              <tr>
                <td>Lluvia García</td>
                <td>Smartphone</td>
              </tr>
              <tr>
                <td>Rosalio Mendoza</td>
                <td>Smartphone</td>
              </tr>

              <tr>
                <td>Arpero Quintana</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Cesar Raymundo Moreno Rodríguez</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Jesus Aguirre</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Jesus Aragón</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Jesus Villareal</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Manuel Ernesto Rodríguez</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Martin López</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>May L</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Raymundo Becerra</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Rene Arvizo</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Teódulo Olivas</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Yesenia González</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
            </table>
          </div>

          <p class="fG text-center bold pb-4 blanco">Ganadores Semana 3</p>

          <div class="fM blanco pb-5">
            <table class="tableganadores">
              <tr>
                <td class="bold fG">Nombre</td>
                <td class="bold fG">Premio</td>
              </tr>

              <tr>
                <td>Eduardo Escobar</td>
                <td>Smart TV 58"</td>
              </tr>
              <tr>
                <td>Gil Enríquez</td>
                <td>Smart TV 58"</td>
              </tr>
              <tr>
                <td>Ricardo Leyva</td>
                <td>Smart TV 58"</td>
              </tr>

              <tr>
                <td>Humberto Ortega</td>
                <td>Smartphone</td>
              </tr>
              <tr>
                <td>Martín Javier Ochoa Hurtado</td>
                <td>Smartphone</td>
              </tr>
              <tr>
                <td>Mónica Valenzuela</td>
                <td>Smartphone</td>
              </tr>
              <tr>
                <td>Olivia Duran</td>
                <td>Smartphone</td>
              </tr>
              <tr>
                <td>Yoselin Valerio</td>
                <td>Smartphone</td>
              </tr>

              <tr>
                <td>Agustín Armando Dávila</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Álvaro Quintana</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Arely Terrazas</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Cesar Raymundo Moreno</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Claudia Nallely Alfaro</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Eber Frías</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Elva Duarte</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Erick Alejandro Juárez</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Ericka Bermúdez</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Erika Robledo</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Felipe Cristobal Carrillo</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Francisco Eduardo Sepúlveda</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Gerardo Ivan Chávez</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Guillermo Duarte</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Julian Carmen Hernández</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Luis Gustavo Aragón</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Luis Zapata</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>María Gonzales</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Mauro González</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Nathan Torres</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Randy Doerksen</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Susana Echavarría</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Valo Quintana</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Víctor Hugo Abundis</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
            </table>
          </div>

          <p class="fG text-center bold pb-4 blanco">Ganadores Semana 4</p>

          <div class="fM blanco pb-5">
            <table class="tableganadores">
              <tr>
                <td class="bold fG">Nombre</td>
                <td class="bold fG">Premio</td>
              </tr>

              <tr>
                <td>Lluvia Garcia</td>
                <td>Smart TV 58"</td>
              </tr>
              <tr>
                <td>Ramon Núñez</td>
                <td>Smart TV 58"</td>
              </tr>
              <tr>
                <td>Samuel Gonzalez</td>
                <td>Smart TV 58"</td>
              </tr>

              <tr>
                <td>Adán Palma</td>
                <td>Smartphone</td>
              </tr>
              <tr>
                <td>David Chávez</td>
                <td>Smartphone</td>
              </tr>
              <tr>
                <td>Marlene Venzor</td>
                <td>Smartphone</td>
              </tr>
              <tr>
                <td>Ricardo Leyva</td>
                <td>Smartphone</td>
              </tr>
              <tr>
                <td>Rubén Ivan Lopez Banda</td>
                <td>Smartphone</td>
              </tr>

              <tr>
                <td>Brenda Diaz</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Cecilia De la Torre</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Eduardo Escobar</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Gustavo Morales</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Jacobo Wolf</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Jose Luis Enríquez</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Luis Enrique Mora Correa</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Miguel Angel Matas Manzano</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Nancy Judith Román</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Omar Miguel Muñoz</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Orlando Polanco</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Rebeca Reyes</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Saul Trevizo Enríquez</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Víctor Hugo Abundis Villa</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
            </table>
          </div>

          <p class="fG text-center bold pb-4 blanco">Ganadores Semana 5</p>

          <div class="fM blanco pb-5">
            <table class="tableganadores">
              <tr>
                <td class="bold fG">Nombre</td>
                <td class="bold fG">Premio</td>
              </tr>

              <tr>
                <td>Berenice Quintana</td>
                <td>Smart TV 58"</td>
              </tr>
              <tr>
                <td>Mariela Morales</td>
                <td>Smart TV 58"</td>
              </tr>
              <tr>
                <td>Rebeca Reyes</td>
                <td>Smart TV 58"</td>
              </tr>

              <tr>
                <td>Cesar Cisneros</td>
                <td>Smartphone</td>
              </tr>
              <tr>
                <td>Daniel Velducea</td>
                <td>Smartphone</td>
              </tr>
              <tr>
                <td>Gonzalo Siañez</td>
                <td>Smartphone</td>
              </tr>
              <tr>
                <td>Samuel Gonzalez</td>
                <td>Smartphone</td>
              </tr>

              <tr>
                <td>Adán Palma</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Cinthia Ortiz</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Daniel Hernandez</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Diana Isabel Hernandez Dominguez</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Edelmira Guillen</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Eduardo Escobar</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Guadalupe Dominguez</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Iris Nava</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Jesus Vaca</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Jorge Márquez</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Julian Carmen Hernandez Amaya</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Lluvia Garcia</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Luis Enrique Mora Correa</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>María Ortiz</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Martha Rios Fabela</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Orlando Polanco</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Raul Ramos</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Ricardo Ivan Alarcón</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Ricardo Leyva</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Rubén Ivan Lopez Banda</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Víctor Hugo Abundis Villa</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
              <tr>
                <td>Yadira Martinez</td>
                <td>Kit 3 Sacos de Cemento</td>
              </tr>
            </table>
          </div>

          <p class="fG text-center bold pb-4 blanco">Ganadores Semana 6</p>

          <div class="fM blanco pb-5">
            <div class="fM blanco pb-5">
              <table class="tableganadores">
                <tr>
                  <td class="bold fG">Nombre</td>
                  <td class="bold fG">Premio</td>
                </tr>

                <tr>
                  <td>Azucena Solorio</td>
                  <td>Smart TV 58"</td>
                </tr>
                <tr>
                  <td>Ricardo Barragán</td>
                  <td>Smart TV 58"</td>
                </tr>
                <tr>
                  <td>Daniela Ramos</td>
                  <td>Smartphone</td>
                </tr>
                <tr>
                  <td>Jesus Villareal</td>
                  <td>Smartphone</td>
                </tr>
                <tr>
                  <td>Leonel Palma</td>
                  <td>Smartphone</td>
                </tr>
                <tr>
                  <td>Miguel Angel Matas Manzano</td>
                  <td>Smartphone</td>
                </tr>
                <tr>
                  <td>Olivia Duran</td>
                  <td>Smartphone</td>
                </tr>
                <tr>
                  <td>Adán Palma</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Bernhard Froesse</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Ciria Daniela Aguilar Hernandez</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Diana Isabel Hernandez Dominguez</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Edgar Alonso Venegas Acosta</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Eduardo Escobar</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Francisco Quezada</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Gabriela Garcia Duarte</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Guadalupe Dominguez Perez</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Humberto Ortega</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Javier Guadalupe</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Juan Alfonso Martinez Bueno</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Julian Carmen Hernandez Amaya</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Lluvia Garcia</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Lourdes Ortiz</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Mario Muñoz</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Orlando Polanco</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Raul Ramos</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Rebeca Reyes</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Ricardo Leyva</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Ricardo Martinez</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Ricardo Meza</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Rubén Ivan Lopez Banda</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Víctor Hugo Abundis Villa</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Viridiana Perez</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
              </table>
            </div>
          </div>

          <p class="fG text-center bold pb-4 blanco">Ganadores Semana 7</p>

          <div class="fM blanco pb-5">
            <div class="fM blanco pb-5">
              <table class="tableganadores">
                <tr>
                  <td class="bold fG">Nombre</td>
                  <td class="bold fG">Premio</td>
                </tr>

                <tr>
                  <td>Cristina Ivette Zavala Ortiz</td>
                  <td>Smart TV 58"</td>
                </tr>
                <tr>
                  <td>Julian Carmen Hernandez Amaya</td>
                  <td>Smart TV 58"</td>
                </tr>
                <tr>
                  <td>Myrna Iliana Correa Ramírez</td>
                  <td>Smart TV 58"</td>
                </tr>

                <tr>
                  <td>Adán Palma</td>
                  <td>Smartphone</td>
                </tr>
                <tr>
                  <td>Ciria Daniela Aguilar Hernandez</td>
                  <td>Smartphone</td>
                </tr>
                <tr>
                  <td>Luis Armando Jaime Muñoz</td>
                  <td>Smartphone</td>
                </tr>
                <tr>
                  <td>Paulina Loya</td>
                  <td>Smartphone</td>
                </tr>

                <tr>
                  <td>Arely Terrazas</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Angel Ramos</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Azucena Solorio</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Berenice Quintana</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Bianca Judith Correa Rodriguez</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Daniela Ramos</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>David Rivera Terrazas</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Diana Isabel Hernandez Dominguez</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Eduardo Escobar</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Guadalupe Dominguez Perez</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Héctor Guadalupe</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Jesus Vaca</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Jorge Alberto Mendoza Parra</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Juan Alfonso Martinez Bueno</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Karla Mendoza</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Leonel Palma</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Lluvia Garcia</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Luis Enrique Mora Correa</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Maria Antonia Lucano</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>María Cruz Aguirre</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Mario Muñoz</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Marlene Venzor</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Melina Jaime</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Miguel Angel Matas Manzano</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Rafael Rodríguez</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Ricardo Anchondo Meza</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Ruth Núñez</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Sergio Eloy Loya Mariscal</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Teódulo Olivas</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Víctor Hugo Abundis Villa</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
              </table>
            </div>
          </div>

          <p class="fG text-center bold pb-4 blanco">Ganadores Semana 8</p>

          <div class="fM blanco pb-5">
            <div class="fM blanco pb-5">
              <table class="tableganadores">
                <tr>
                  <td class="bold fG">Nombre</td>
                  <td class="bold fG">Premio</td>
                </tr>

                <tr>
                  <td>Carmen Molina Olivas</td>
                  <td>Smart TV 58"</td>
                </tr>
                <tr>
                  <td>Jesus Javier Carrillo Regalado</td>
                  <td>Smart TV 58"</td>
                </tr>
                <tr>
                  <td>Leonel Palma</td>
                  <td>Smart TV 58"</td>
                </tr>
                <tr>
                  <td>Sergio Eloy Loya Mariscal</td>
                  <td>Smart TV 58"</td>
                </tr>
               
                <tr>
                  <td>Adán Palma</td>
                  <td>Smartphone</td>
                </tr>
                <tr>
                  <td>Dania Quintana</td>
                  <td>Smartphone</td>
                </tr>
                <tr>
                  <td>David Carbajal</td>
                  <td>Smartphone</td>
                </tr>
                <tr>
                  <td>Emilio Avalos</td>
                  <td>Smartphone</td>
                </tr>
                <tr>
                  <td>Humberto Córdova</td>
                  <td>Smartphone</td>
                </tr>
                <tr>
                  <td>Luis Fernando Mora Sanchez</td>
                  <td>Smartphone</td>
                </tr>
                <tr>
                  <td>Marcela Hernandez</td>
                  <td>Smartphone</td>
                </tr>
                <tr>
                  <td>Myrna Iliana Correa Ramírez</td>
                  <td>Smartphone</td>
                </tr>
               
                <tr>
                  <td>María Rita Cruz Aguirre</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Orlando Polanco</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Daniela Ramos</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Mario Muñoz</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Teódulo Olivas</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Paulina Loya</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Berenice Quintana</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Cristina Muñoz</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Raul Ramos</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Luis Enrique Mora Correa</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Cristina Ivette Zavala Ortiz</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Judith Molina</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Angel Ramos</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Alejandro Gonzalez</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Laura Rodriguez</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Jesus Briseño</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Alely Terrazas</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Edgar Herrera Rivera</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Karina Gabaldón</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Melina Jaime</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Ricardo Leyva</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Miguel Angel Matas Manzano</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Fátima Ramos</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Gabriela Rodriguez Vargas</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Olivia Duran</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Luis Armando Jaime Muñoz</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Marlene Sandoval</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Bianca Judith Correa Rodriguez</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Guillermo Alejandro</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Víctor Hugo Abundis Villa</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Noel Fuentes</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Juan Alfonso Martinez Bueno</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Gerardo Arturo Villalobos Ch</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Laura Gutiérrez</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Randy Doerksen</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Mariela Morales</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Susana Gaytán</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Miguel Angel Matas Manzano</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Álvaro Quintana</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Miguel Angel Ramos</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Israel Loyo</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Adán Palma</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Juan Manuel Sánchez Domínguez</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Alejandro Cruz Peña</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Erika Robledo</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Maria Esther Pérez Mendoza</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Ana Priscilla Sanora Mendoza</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Melina Jaime</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Bernhard Froesse</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Jesus Argón</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Randy Doerksen</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Alejandro Gonzalez</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Edgar Iván Espino Martínez</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Angel Ramos Ramos</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Juan Alfonso Martinez Bueno</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Guillermo Alejandro</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Leonel Palma</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>María Rita Cruz Aguirre</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Marlene Venzor</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Mario Muñoz</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Joan Eduardo Contreras Ponce</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Luis Carlos Montañez Padilla</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Jorge Alberto Mendoza Parra</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Anabel Nieto</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Manuel Botello</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Luis Miguel Guzmán</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Noel Fuentes</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Mirna Mireya Ayala Téllez</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Edgar Alonso Venegas Acosta</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Luis Fernando Mora Sanchez</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Norma Irene Portillo Meraz</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Bethania Solís</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Daniel Armendáriz Flores</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Gerardo Sandoval</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Susana Gonzalez</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Flor Julieta Acosta Garcia</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
                <tr>
                  <td>Jose Luis Aragón</td>
                  <td>Kit 3 Sacos de Cemento</td>
                </tr>
              </table>
            </div>
          </div>

          <router-link
            to="/dashboard"
            class="
              negro
              pointer
              d-flex
              align-items-center
              justify-content-center
              fG
              ml-auto
              mr-auto
              w-100
              bold
            "
          >
            <span
              class="
                btnaction
                d-flex
                align-items-center
                justify-content-center
                fG
                ml-auto
                mr-auto
                w-100
                bold
                nounderline
              "
            >
              REGRESAR
            </span>
          </router-link>
        </div>
      </div>
    </div>

    <Footer></Footer>

    <!-- <div class="hidden" v-for="(img) in disponibles" :key="img">
        <img
         rel="preload"
          :src="require('../assets/imgs/juego/matches/' + img + '-1.png')"
          alt="flecha"
        />
        <img
         rel="preload"
          :src="require('../assets/imgs/juego/matches/' + img + '-2.png')"
          alt="flecha"
        />
      </div>
      <div class="hidden" v-for="(img) in dulceria" :key="img">
        <img
         rel="preload"
          :src="require('../assets/imgs/juego/matches/' + img + '-1.png')"
          alt="flecha"
        />
        <img
         rel="preload"
          :src="require('../assets/imgs/juego/matches/' + img + '-2.png')"
          alt="flecha"
        />
      </div> -->

    <div
      class="overlayticket overlay-sucursal"
      v-if="overlay_sucursal === true"
    >
      <div class="bg-overlay" @click="toggleSucursal"></div>
      <div class="ticket shadow rounded bg-moradooscuro">
        <div class="head">
          <div
            class="cerrar p-2 d-block fG pointer amarillo monts"
            @click="toggleSucursal"
          >
            cerrar
          </div>
        </div>
        <div class="body text-center w-100">
          <div class="titulo fG amarillo bold">Número de sucursal:</div>
          <img
            class="img-fluid p-4"
            src="../assets/imgs/homeins/ticket-sucursal.jpg"
            alt="Raspa y Gana"
          />
        </div>
      </div>
    </div>

    <div
      class="overlayticket overlay-sucursal"
      v-if="overlay_transaccion === true"
    >
      <div class="bg-overlay" @click="toggleTransaccion"></div>
      <div class="ticket shadow rounded bg-moradooscuro">
        <div class="head">
          <span
            class="cerrar p-2 d-block fG pointer amarillo monts"
            @click="toggleTransaccion"
            >cerrar</span
          >
        </div>
        <div class="body text-center w-100">
          <div class="titulo fG amarillo bold">Número de transacción:</div>
          <img
            class="img-fluid p-4"
            src="../assets/imgs/homeins/ticket-transaccion.jpg"
            alt="Raspa y Gana"
          />
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { commentsCollection } from "@/firebase";
import { mapState } from "vuex";
import moment from "moment";
import AOS from "aos";
import swal from "sweetalert2";

import Footer from "@/components/Footer";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      post: {
        content: "",
      },
      showCommentModal: false,
      selectedPost: {},
      showPostModal: false,
      fullPost: {},
      postComments: [],
      file: null,
      monedero: "",
      no_transaccion: null,
      no_sucursal: null,
      disponibles: [
        "merida",
        "fantasma",
        "forrest",
        "gladiador",
        "id4",
        "lalaland",
        "malefica",
        "parque-jurasico",
        "psicosis",
        "pulp",
        "et",
        "chucky",
        "diario",
        "wolverine",
        "piratas",
        "peterpan",
        "titanic",
        "lord",
        "karate",
        "silencio",
        "kill",
        "godfather",
        "resplandor",
        "mary",
        "mago",
        "blackpanther",
        "corazon",
        "inception",
        "harry",
        "simpsons",

        "aladino",
        "alicia",
        "alien",
        "ava",
        "baby",
        "batman",
        "bella",
        "ben",
        "big",
        "blancanieves",

        "buscando",
        "capitan",
        "car",
        "cenicienta",
        "coco",
        "dama",
        "dirty",
        "dracula",
        "emperor",
        "escuadron",

        "exorcista",
        "froz",
        "hombres",
        "home",
        "hunger",
        "ice",
        "increibles",
        "indiana",
        "iron",
        "it",

        "kung",
        "lilo",
        "mati",
        "matrix",
        "mega",
        "mision",
        "moa",
        "monsters",
        "mulan",
        "naufrago",

        "nosotros",
        "pesadilla",
        "picapiedra",
        "pino",
        "poca",
        "quien",
        "quinto",
        "rapsodia",
        "rata",
        "reyleon",

        "rock",
        "sabueso",
        "scooby",
        "shrek",
        "sirenita",
        "spiderman",
        "starwars",
        "super",
        "tarzan",
        "termi",

        "thor",
        "tiburon",
        "tomb",
        "top",
        "toy",
        "trans",
        "up",
        "vase",
        "villano",
        "volver",

        "wall",
        "wonder",
      ],
      dulceria: [
        "dulceria1",
        "dulceria2",
        "dulceria3",
        "dulceria4",
        "dulceria5",
        "dulceria6",
        "dulceria7",
        "dulceria8",
        "dulceria9",
        "dulceria10",
        "dulceria11",
      ],
      overlay_transaccion: false,
      overlay_sucursal: false,
    };
  },
  computed: {
    ...mapState(["userProfile", "posts"]),
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
  },
  methods: {
    // async jugar() {
    //   this.$store.commit(
    //     "setTicketID",
    //     this.userProfile.ultimo_ticket_registrado
    //   );
    //   this.$router.push("/dinamica");
    // },
    fileSelected: function ($event) {
      this.file = $event.target.files[0];

      var reader = new FileReader();

      reader.onload = function (e) {
        // get loaded data and render thumbnail.
        var preview = document.getElementById("preview");
        var image = document.createElement("img");
        image.src = e.target.result;
        preview.innerHTML = "";
        preview.appendChild(image);
        console.log(preview);

        swal.fire(
          "Bien",
          "Recuerda conservar tus tickets de compra, da click en continuar para participar.",
          "success"
        );
      };

      // read the image file as a data URL.
      reader.readAsDataURL(this.file);
    },
    async tomarTrivia() {
      if (this.file == null) {
        swal.fire(
          "Oops",
          "Sube la foto de un ticket antes de continuar...",
          "warning"
        );
        return;
      }

      await this.$store.dispatch("registroTicket", {
        file: this.file,
      });

      this.file = null;
      var preview = document.getElementById("preview");
      preview.innerHTML = "";
    },
    toggleSucursal() {
      this.overlay_sucursal = !this.overlay_sucursal;
    },
    toggleTransaccion() {
      this.overlay_transaccion = !this.overlay_transaccion;
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }

      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.overlayticket {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100000;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  .bg-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
  }
  .ticket {
    width: 50%;
    margin: 0 25%;
    .head {
      width: 100%;
      .cerrar {
        text-align: right;
        cursor: pointer;
        user-select: none;
      }
    }
    .body {
    }
  }
}
</style>
  